import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import AlgoliaSelect from "./index";

type AlgoliaSelectProps = React.ComponentProps<typeof AlgoliaSelect>;

export type ControlledAlgoliaSelectProps = Omit<
  AlgoliaSelectProps,
  "onChange" | "value" | "connected"
> & {
  name: string;
  onChange?: (newValue: any) => void;
};

export function ControlledAlgoliaSelect({
  name,
  onChange,
  ...props
}: ControlledAlgoliaSelectProps) {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => {
        // Extract ref from field to avoid forwardRef issues with generic typing
        const { ref: _, ...fieldWithoutRef } = field;

        return (
          <AlgoliaSelect
            {...props}
            {...fieldState}
            {...fieldWithoutRef}
            hasCustomValidation={!!fieldState?.error?.message}
            hasErrorOverride={!!fieldState?.error?.message}
            validation={
              fieldState?.error?.message
                ? ({ infos: fieldState.error.message } as any)
                : undefined
            }
            onChange={(newValue) => {
              field.onChange(newValue);
              if (onChange) onChange(newValue);
            }}
          />
        );
      }}
    />
  );
}

ControlledAlgoliaSelect.displayName = "DSL.ControlledAlgoliaSelect";
